var map = {
	"./Hero_Image_Desktop_9.jpg": 542,
	"./Hero_Image_Mobile_9.jpg": 543,
	"./Hero_Image_Tablet_9.jpg": 544,
	"./how-to-cut-your-foods-climate-emissions.jpg": 545,
	"./how-we-can-adapt-plants-to-save-our-planet.jpg": 546,
	"./the-race-to-improve-food-security.jpg": 547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 318;